import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { LogoMark } from "./Logo";
import { SITE } from "@/config/site";

const LINKS = [
  { to: "/", label: "Home", id: "home" },
  { to: "/menu", label: "Menù", id: "menu" },
  { to: "/contatti", label: "Contatti", id: "contatti" },
];

export const Navbar = () => {
  const { pathname } = useLocation();
  return (
    <header className="fixed top-0 inset-x-0 z-50 px-3 sm:px-6 pt-3 sm:pt-5">
      <nav className="mx-auto max-w-7xl flex items-center justify-between gap-2 rounded-full border border-white/10 bg-[#0D0D0F]/70 backdrop-blur-xl p-1.5 sm:p-2 shadow-2xl">
        <Link to="/" data-testid="nav-logo" className="group flex items-center gap-2.5 pl-1">
          <LogoMark className="w-9 h-9 transition-transform duration-500 group-hover:rotate-[-12deg]" />
          <span className="hidden sm:block font-display text-lg uppercase tracking-tight">Mister Pollo</span>
        </Link>
        <div className="flex items-center gap-0.5 sm:gap-1">
          {LINKS.map((l) => {
            const active = l.to === "/" ? pathname === "/" : pathname.startsWith(l.to);
            return (
              <Link key={l.id} to={l.to} data-testid={`nav-link-${l.id}`} className="relative px-3.5 sm:px-5 py-2 rounded-full text-sm font-semibold">
                {active && (
                  <motion.span layoutId="nav-pill" className="absolute inset-0 rounded-full bg-[#FF5500]" transition={{ type: "spring", stiffness: 420, damping: 34 }} />
                )}
                <span className={`relative z-10 transition-colors ${active ? "text-[#0D0D0F]" : "text-white/80 hover:text-white"}`}>{l.label}</span>
              </Link>
            );
          })}
        </div>
        <a
          href={SITE.whatsappHref}
          target="_blank"
          rel="noreferrer"
          data-testid="nav-cta-ordina"
          className="group hidden md:inline-flex items-center gap-2 rounded-full bg-[#FFF4E8] text-[#0D0D0F] px-5 py-2.5 text-sm font-bold transition-colors hover:bg-[#FF5500]"
        >
          Ordina ora
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:rotate-45" />
        </a>
      </nav>
    </header>
  );
};
